<div class="fixed-section">
    <section class="titleBarBg fixed-top">
        <div class="container-fluid">
            <div class="row mar-7px">
                <div class="w-3">
                    <img src="assets/images/manageStore_wt.png" class="pageIcon" alt="">
                </div>
                <div class="w-97">
                    <div class="pageHeadingBar">
                        <div class="row">
                            <div class="col-md-6 align-self-center">
                                <h6 class="pageHeadingText mb-0 text-uppercase"> MANAGE STORE COVERAGE</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

<div class="middleContent">
    <section class="mt-131">
        <div class="container-fluid px-2">
            <div class="row">
                <div class="col-md-12">
                    <div class="card border-0 stepsBars-2 mb-5">
                        <div class="card-body">
                            <div class="row align-items-center justify-content-between">
                                <!-- LEFT SECTION: SEARCH BY + filters -->
                                <div class="col d-flex align-items-center flex-wrap">
                                    <!-- Search by label -->
                                    <h6 class="loginHeadingText text-start mb-0 me-3">SEARCH BY</h6>

                                    <!-- Title -->
                                    <div class="d-flex align-items-center me-3">
                                        <label class="me-2 mb-0">TITLE</label>
                                        <div class="position-relative">
                                            <input type="text" class="form-control" placeholder="Title"
                                            style="width: 250px" (keyup)="onTitleChange($event)" [(ngModel)]="txtSearchTitle">
                                            <img src="assets/images/magnifying-glass.png" class="glassIcon" alt="">
                                        </div>
                                    </div>

                                    <!-- Category -->
                                    <div class="d-flex align-items-center me-3">
                                        <label class="me-2 mb-0">CATEGORY</label>
                                        <p-multiSelect [options]="categoryList" [(ngModel)]="selectedCategories"
                                            name="category" [showHeader]="true" [filter]="true"
                                            placeholder="Select Category" optionLabel="categoryName"
                                            (click)="stopPropagation($event)"
                                            (ngModelChange)="onSelectedCategory($event)">
                                            <ng-template let-category pTemplate="item">
                                                <div class="hover-item" title="{{category.categoryName}}">
                                                    {{ category.categoryName }}
                                                </div>
                                            </ng-template>
                                        </p-multiSelect>
                                    </div>

                                    <!-- Date range -->
                                    <div class="d-flex align-items-center me-3">
                                        <label class="me-2 mb-0">DATE RANGE</label>
                                        <p-calendar name="dateCalendar" dateFormat="dd-M-yy"
                                            [(ngModel)]="selectedDateRange" (click)="stopPropagation($event)"
                                            [style]="{'width':'200px','margin-top':'-3px','height':'32px !important', 'padding-top':'4px'}"
                                            (ngModelChange)="selectedSubmittedDateRange()" selectionMode="range">
                                        </p-calendar>
                                    </div>

                                    <!-- Clear filter -->
                                    <button *ngIf="isFilterApplied" type="button" class="btn progressBtn me-2" (click)="clearFilter()">
                                        <img src="assets/images/close_mark.svg" class="datePickerIcon" alt="">
                                        CLEAR FILTER
                                    </button>
                                </div>

                                <!-- RIGHT SECTION: ADD STORE COVERAGE -->
                                <div class="col-auto text-end">
                                    <button class="btn progressBtn ps-2 me-1" role="button" data-bs-toggle="modal"
                                        data-bs-target="#exampleModal" (click)="addStoreCoverage()">
                                        <div class="d-flex align-items-center">
                                            <img src="assets/images/plus_icon.svg" class="btnrefreshIcon me-1" alt="">
                                            <span>ADD STORE COVERAGE</span>
                                        </div>
                                    </button>
                                </div>
                            </div>

                            <div class="table-responsive tableFixHead mt-3">
                                <table class="table datatable border-x-0 mb-0">
                                    <thead>
                                        <tr class="subheaderrr">
                                            <th width="18%">
                                                TITLE
                                            </th>
                                            <th width="10%">
                                                CATEGORY
                                            </th>
                                            <th width="9%">
                                                DATE
                                            </th>
                                            <th width="9%">
                                                REPORT
                                            </th>
                                            <th width="9%">
                                                ACTION
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let storeCoverage of lstStoreCoverageData;">
                                            <td class="text-center vertical-align-middle titleTdBg">
                                                {{storeCoverage.title}}
                                            </td>
                                            <td class="text-center vertical-align-middle">
                                                {{storeCoverage.categoryName}}
                                            </td>
                                            <td class="text-center vertical-align-middle">
                                                {{ storeCoverage.storeCoverageDate | date:'dd-MMM-yyyy' }}
                                            </td>
                                            <td class="text-center vertical-align-middle">
                                                <img src="assets/images/office365.png" alt="" class="excelIconn"
                                                    (click)="downloadStoreCoverageReportExcel($event, storeCoverage)"
                                                    title="Store Coverage Report" style="cursor:pointer;">
                                            </td>
                                            <td width="2%" class="vertical-align-middle text-center">
                                                <a href="javascript:void(0)" (click)="editStoreCoverage(storeCoverage)">
                                                    <img src="assets/images/pencilIocn.svg" class="me-1 w-21" alt=""
                                                        style="cursor: pointer;" title="Edit">
                                                </a>
                                                <img src="assets/images/close_mark.svg" title="Delete" alt=""
                                                    class="pointer-icon" style="height:20px;width:23px;cursor: pointer;"
                                                    (click)="deleteStoreCoverage(storeCoverage)" />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div class="card" *ngIf="lstStoreCoverageData!.length === 0 ">
                                    <div class="card-body py-2 px-3">
                                        <div class="emtyCard p-0">
                                            <p class="mb-0">No Records Found
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

<div class="modal fade mt-131" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header py-2" style="font-weight: bold;">{{selectedAction}} STORE COVERAGE
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <app-add-edit-store-coverage [storeCoverageData]="selectedStoreCoverage"
                    [originalStoreCoverage]="originalStoreCoverage" [selectedAction]="selectedAction"
                    (saveSuccess)="onSaveSuccess()"></app-add-edit-store-coverage>
            </div>
        </div>
    </div>
</div>

<p-confirmDialog position="top" [baseZIndex]="200000" appendTo="body" role="alertdialog"></p-confirmDialog>